<template>
  <div v-if="lastLoginMethod" class="qa-mask-wrap02 mail-btn">
    <p class="qa-mask-bg">
      登録すると回答を閲覧することができます。登録すると回答を閲覧することができます。登録すると回答を閲覧することができます。登録すると回答を閲覧することができます。登録すると回答を閲覧することができます。登録すると回答を閲覧することができます。登録すると回答を閲覧することができます。登録すると回答を閲覧することができます。
    </p>
    <p><b>ログインして回答を見る</b></p>
    <p class="qa-login-method-sub"><span class="material-icons">check_circle</span>前回{{ lastLoginMethod }}でログインしました</p>
    <div class="mail-btn-wrap push-top">
      <a href="/login" class="button button--primary button--lg">
        ログイン画面に進む
      </a>
    </div>
  </div>
  <div v-else>
    <p class="social-dialog-txt">
      <small>
        <a href="/open/terms/" target="_blank">利用規約</a>と<a
          href="http://corporate.m3.com/privacy/"
          target="_blank"
          >個人情報の取り扱い</a
        >に<br />
        同意のうえ、無料会員登録をしてください
      </small>
    </p>

    <div class="social-switch push-bottom">
      <p class="social-switch-txt">
        <small>AskDoctorsお役立ちメルマガを受け取る</small>
      </p>
      <div class="toggle-switch push-left">
        <input
          id="toggle-switch"
          class="toggle-switch-input"
          type="checkbox"
          v-model="receivesMail"
        />
        <label for="toggle-switch" class="toggle-switch-label"></label>
      </div>
    </div>
    <div class="qa-mask-wrap01 social-btn">
      <p class="qa-mask-bg">
        登録すると回答を閲覧することができます。登録すると回答を閲覧することができます。登録すると回答を閲覧することができます。登録すると回答を閲覧することができます。登録すると回答を閲覧することができます。登録すると回答を閲覧することができます。登録すると回答を閲覧することができます。登録すると回答を閲覧することができます。登録すると回答を閲覧することができます。登録すると回答を閲覧することができます。
      </p>
      <div class="qa-mask-inr">
        <div class="google-btn">
          <a :href="googleUrl">
            <p class="google-btn-logo">
              <img src="~green/logo/logo_google.svg" alt="" />
            </p>
            <p class="google-btn-txt">
              Googleアカウントで<br class="mobile-only" />{{
                socialButtonTextSuffix
              }}
            </p>
          </a>
        </div>
        <div class="yahoo-btn">
          <a :href="yahooUrl">
            <p class="yahoo-btn-logo">
              <img src="~green/logo/logo_yahoo.png" alt="" />
            </p>
            <p class="yahoo-btn-txt">
              Yahoo! JAPAN ID<br class="mobile-only" />で{{
                socialButtonTextSuffix
              }}
            </p>
          </a>
        </div>
        <div class="line-btn">
          <a :href="lineUrl">
            <p class="line-btn-logo">
              <img src="~green/logo/logo_line.png" alt="" />
            </p>
            <p class="line-btn-txt">LINEで{{ socialButtonTextSuffix }}</p>
          </a>
        </div>
        <div class="apple-btn">
          <a :href="appleUrl">
            <p class="apple-btn-logo">
              <img src="~green/logo/logo_apple.png" alt="" />
            </p>
            <p class="apple-btn-txt">Appleでサインアップ</p>
          </a>
        </div>
        <p class="social-dialog-txt">
          <small>※個人のSNSに利用状況は投稿されません</small>
        </p>
      </div>
    </div>
    <p class="push-top--sm push-bottom--sm social-dialog-txt">または</p>
    <div class="qa-comment-mask-btn push-bottom">
      <p class="social-dialog-txt">
        <a
          class="email-btn button button--tertiary button--md"
          :href="emailRegistrationUrl"
          >メールアドレスで{{ emailButtonTextSuffix }}</a
        >
      </p>
      <div class="login-link text-center">
        <p>アカウントをお持ちの方は<a href="/login">ログイン</a>へ</p>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../common/routings/utils';

export default {
  props: {
    additionalParams: Object,
    emailRegistrationUrl: String,
    lastLoginMethod: { type: String, default: null },
    // 有料登録フローに誘導する場合は「続ける」「登録」としていたケースもあったが、
    // その場合でもまず無料登録を行うのは確かなので（その後課金ページに誘導するとしても）、
    // 基本的にはすべて「無料登録」という文言で統一してよい。
    // むしろ「続ける」は無料登録することに言及しないので、クレームの元ではないかとも考えられた。
    socialButtonTextSuffix: { type: String, default: '無料登録' },
    emailButtonTextSuffix: { type: String, default: '無料登録' }
  },

  data() {
    return {
      receivesMail: true
    };
  },

  computed: {
    queryParams() {
      return {
        ...this.additionalParams,
        send_ask_doctors_email: this.receivesMail ? '1' : '0'
      };
    },

    googleUrl() {
      return this.buildURL('google');
    },

    yahooUrl() {
      return this.buildURL('yahoojp');
    },

    lineUrl() {
      return this.buildURL('line');
    },

    appleUrl() {
      return this.buildURL('apple');
    }
  },

  methods: {
    buildURL(provider) {
      return utils.buildURL('/user/free_registration_session/new', {
        ...this.queryParams,
        provider: provider
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~green/_variables.scss';
@import '~green/_mixin.scss';
@import '~green/object/project/_login.scss';

.social {
  &-dialog {
    &-txt {
      margin: 0 auto 16px;
      width: 100%; // IE対策
      font-size: 16px;
      font-size: 1rem;
      color: $base-font-color;
      text-align: center;
      @media (max-width: $width-tablet-min) {
        font-size: 14px;
        font-size: 0.875rem;
      }
      a {
        text-decoration: underline;
        &:hover {
          text-decoration: none;
        }
      }
    }
    &-btn {
      margin: 0 auto 8px;
      @media (max-width: $width-tablet-min) {
        margin: 0 auto 16px;
      }
    }
    .line-btn,
    .yahoo-btn,
    .google-btn,
    .apple-btn,
    .email-btn {
      width: 100% !important;
      @media (max-width: 1032px) {
        width: 100% !important;
      }
    }
    .email-btn {
      padding: 8px;
      font-size: 14px;
      font-size: 0.875rem;
    }
  }
  &-switch {
    width: 100%; // IE対策
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.login-link {
  font-size: 0.875rem;
  a {
    text-decoration: underline;
  }
}
</style>
